import { GDTMessageGroup } from '@lmt/shared-types';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export function useGDTMessageGroupsList() {
  const i18n = useTranslation();
  return useMemo(() => {
    return [
      {
        value: GDTMessageGroup.DataBlock,
        displayValue: i18n.t('gdt.template_rules.template_types.data_block'),
      },
      {
        value: GDTMessageGroup.Document,
        displayValue: i18n.t('gdt.template_rules.template_types.document'),
      },
    ];
  }, [i18n.i18n.language]);
}
